module.exports = __webpack_public_path__ + "static/img/taijia.7d26595.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/taijia.png
// module id = TyTs
// module chunks = 1